import {ButtonProps, ListItemButton} from "@mui/material";
import {Link, useLocation} from "react-router-dom";
import React from "react";
import {CustomLink} from "../CustomLink/CustomLink";

interface HeaderLinkProps extends ButtonProps{
    to: string;
}
export const ListHeaderLink = (props:HeaderLinkProps) => {
    let location = useLocation();
    let from = location.pathname || "/";
    return (<ListItemButton disableRipple sx={{pl:3,color: (theme)=>theme.palette.primary.contrastText}} component={CustomLink} to={props.to} onClick={(event) => {
        props.onClick?.(event as unknown as  React.MouseEvent<HTMLButtonElement,MouseEvent>);
    }}>{props.children}</ListItemButton>)
}